import React from "react";
import { Spin } from "antd";

import RootTree from "./root-tree";
import RegionsTree from "./regions-tree";
import HousesTree from "./houses-tree";

const Tree = ({ form, loading, addresses, showEntity }) => {
	return (
		<div className="tree-container">
			{loading && (
				<Spin
					className="loading"
					size="large"
					spinning={loading}
					tip="Загрузка..."
					delay={100}
				/>
			)}
			{showEntity === "root" && <RootTree addresses={addresses} form={form} />}
			{showEntity === "regions" && (
				<RegionsTree companyObj={addresses} form={form} />
			)}
			{showEntity === "houses" && (
				<HousesTree streetObj={addresses} form={form} />
			)}
		</div>
	);
};

export default Tree;
